import React from "react";

const MetierProcess = () => {
  const processSteps = [
    {
      number: 1,
      title: "Audit gratuit",
      description: "Analyse de vos flux de déchets et besoins spécifiques",
      bgColor: "bg-fabre-green"
    },
    {
      number: 2,
      title: "Solution sur-mesure",
      description: "Proposition d'une solution adaptée à votre activité",
      bgColor: "bg-fabre-teal"
    },
    {
      number: 3,
      title: "Collecte et tri",
      description: "Mise en place de la collecte régulière et du tri sélectif",
      bgColor: "bg-fabre-darkgreen"
    },
    {
      number: 4,
      title: "Valorisation",
      description: "Transformation de vos déchets en nouvelles ressources",
      bgColor: "bg-fabre-green"
    }
  ];

  return (
    <section className="mb-16">
      <div className="bg-gradient-to-br from-fabre-lightgray to-white rounded-3xl shadow-xl p-8 border border-gray-100">
        <h2 className="text-3xl font-heading font-bold mb-8 text-fabre-gray text-center">
          Notre processus de gestion
        </h2>
        <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-12 rounded-full"></div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {processSteps.map((step) => (
            <div key={step.number} className="text-center">
              <div className={`${step.bgColor} text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold`}>
                {step.number}
              </div>
              <h3 className="text-lg font-heading font-bold mb-2 text-fabre-gray">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetierProcess;